import { LegalPageFrame, LegalParagraph, LegalSectionView } from '@/components/legal/legal-document';
import { PaymentsTermsSection } from '@/components/legal/payments-terms-section';
import { SeoHead, SITE_URL } from '@/components/seo-head';
import { LEGAL_DISCLAIMER } from '@/content/legal/privacy';
import {
  TERMS_DESCRIPTION,
  TERMS_PATH,
  TERMS_PAYMENTS_SECTION_NUMBER,
  TERMS_SECTIONS_AFTER_PAYMENTS,
  TERMS_SECTIONS_BEFORE_PAYMENTS,
  TERMS_TITLE,
  TERMS_UPDATED_AT,
  TERMS_UPDATED_LABEL,
} from '@/content/legal/terms';
import { pageTitle } from '@/lib/seo/meta';
import React from 'react';

/** Termos de uso (`/terms`): a única versão dos termos. Texto em `content/legal/terms.ts`. */
export default function TermsScreen() {
  const jsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${SITE_URL}${TERMS_PATH}#page`,
      url: `${SITE_URL}${TERMS_PATH}`,
      name: TERMS_TITLE,
      description: TERMS_DESCRIPTION,
      inLanguage: 'pt-BR',
      dateModified: TERMS_UPDATED_AT,
      isPartOf: { '@id': `${SITE_URL}/#website` },
      publisher: { '@id': `${SITE_URL}/#organization` },
    },
  ];

  return (
    <LegalPageFrame
      screenTitle={TERMS_TITLE}
      head={
        <SeoHead
          title={pageTitle(TERMS_TITLE)}
          description={TERMS_DESCRIPTION}
          path={TERMS_PATH}
          jsonLd={jsonLd}
        />
      }
      title={TERMS_TITLE}
      meta={TERMS_UPDATED_LABEL}
      footerLinks={[{ label: 'Política de privacidade', href: '/privacidade' }]}
    >
      {TERMS_SECTIONS_BEFORE_PAYMENTS.map((section) => (
        <LegalSectionView key={section.id} section={section} />
      ))}
      <PaymentsTermsSection sectionNumber={TERMS_PAYMENTS_SECTION_NUMBER} />
      {TERMS_SECTIONS_AFTER_PAYMENTS.map((section) => (
        <LegalSectionView key={section.id} section={section} />
      ))}
      <LegalParagraph>{LEGAL_DISCLAIMER}</LegalParagraph>
    </LegalPageFrame>
  );
}
